//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/pmUsers/views/main/lan/en';
import createUser from 'Modules/pmUsers/.components/createEditUser/lan/en';
import deleteUser from 'Modules/pmUsers/.components/deleteUser/lan/en';
import resetUser from 'Modules/pmUsers/.components/resetPassword/lan/en';
import jiraSummary from 'Modules/pmUsers/views/jiraSummary/lan/en';
import userDetails from 'Modules/pmUsers/views/jiraSummary/.components/userDetails/lan/en';

locales = { ...locales, ...main, ...createUser, ...deleteUser, ...resetUser, ...jiraSummary, ...userDetails };


export default locales;